import { createPlugin } from '@backstage/core-plugin-api'
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRoot
} from '@backstage/plugin-techdocs-react'
import { useEffect } from 'react'

const techdocsShadowBodyFixPlugin = createPlugin({
  id: 'techdocsShadowBodyFix'
})

/**
 * The MkDocs content lives inside a shadow DOM. Backstage overrides the
 * sidebar to `position: fixed`, which takes it out of document flow. As a
 * result, the inner <body> height is determined solely by the article content,
 * not the sidebar. When the sidebar is taller than the content, it visually
 * overflows below the inner <body>'s grey background onto the outer (white-ish)
 * Backstage body.
 *
 * Setting `min-height: 100vh` on the inner <html>/<body> ensures the grey
 * background covers the full viewport — wherever the fixed sidebar can appear.
 */
const ShadowBodyFixComponent = () => {
  const shadowRoot = useShadowRoot()

  useEffect(() => {
    if (!shadowRoot) return
    if (shadowRoot.querySelector('style[data-shadow-body-fix]')) return

    const style = document.createElement('style')
    style.setAttribute('data-shadow-body-fix', '')
    style.textContent = 'html, body { min-height: 100vh; }'
    ;(shadowRoot.querySelector('head') ?? shadowRoot).appendChild(style)
  }, [shadowRoot])

  return null
}

export const TechDocsShadowBodyFix = techdocsShadowBodyFixPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsShadowBodyFix',
    location: TechDocsAddonLocations.Content,
    component: ShadowBodyFixComponent
  })
)
